import MODS from './Modules/Modules.js'
import shaders from './Modules/shaders.js'

import * as THREE from 'three'

let instance = null

export default class App {
    constructor()
    {
        // Singleton
        if(instance)
        {
            return instance
        }

        // Initial Setup
        instance = this
        this.canvas = document.querySelector('canvas.webgl')
        this.shaders = shaders

        // Setup Utils
        this.time = new MODS.Time()
        this.sizes = new MODS.Sizes(this.canvas)
        this.input = new MODS.Input()

        // Setup Experience
        this.perScene = new THREE.Scene()
        this.ortScene = new THREE.Scene()

        this.cameras = new MODS.Camera()
        this.renderer = new MODS.Renderer()

        // Setup Environment
        this.environment = new MODS.Environment()

        // Events
        this.sizes.on('resize', () => this.resize())
        this.time.on('tick', () => this.update())
    }

    /**
     * Callback Functions
     */
    resize() {
        this.cameras.resize()
        this.renderer.resize()
    }

    update() {
        this.environment.update()
        this.cameras.update()
        this.renderer.update()
    }

    destroy() {
        // Delete Events
        this.sizes.off('resize')
        this.time.off('tick')

        // Delete Objects
        this.perScene.traverse((child) => {
            if(child instanceof THREE.Mesh)
            {
                child.geometry.dispose()

                for(const key in child.material)
                {
                    const value = child.material[key]

                    if(value && typeof value.dispose === 'function')
                    {
                        value.dispose()
                    }
                }
            }
        })

        this.ortScene.traverse((child) => {
            if(child instanceof THREE.Mesh)
            {
                child.geometry.dispose()

                for(const key in child.material)
                {
                    const value = child.material[key]

                    if(value && typeof value.dispose === 'function')
                    {
                        value.dispose()
                    }
                }
            }
        })

        // Delete Controls
        this.cameras.destroy()

        // Delete Renderer
        this.renderer.destroy()

        // Delete Debug
        this.environment.destroy()
    }
}